import React from "react"
import { useEffect } from 'react';
import { useParams } from "react-router-dom";

import Footer2 from "../components/Footer2";
import NavbarProject from "../components/NavbarProject";
import NextProjects from "../components/NextProjects";

// //projects import
import menu_projects from '../data/menu_projects';

export default function Project() {
  const { id } = useParams();

  var index = menu_projects.findIndex(function (item, i) {
    return item.id === id
  });

  var found = menu_projects[index];

  // < !-- < body class="film-template-default single single-film postid-653 is-loaded" style = "background-color:#0a0202;--color-base:#0a0202;color:#ffffff;--color-contrast:#ffffff;" data - cursor="pointer" > -->

  useEffect(() => {
    document.body.classList.add('film-template-default');
    document.body.classList.add('single');
    document.body.classList.add('single-film');
    document.body.classList.add('postid-51');
    document.body.classList.add('is-loaded');

    return () => {
      // document.body.classList.remove('home');
      // document.body.classList.remove('page-template-default');
      // document.body.classList.remove('page');
      // document.body.classList.remove('page-id-2');
      // document.body.classList.remove('page-startseite');
    };
  }, []);

  return (
    <React.Fragment>

      {/* <div className="Cursor js-cursor is-visible" style={{ left: '430px', top: '879px' }} ><i></i></div> */}

      <NavbarProject data={found} />

      <main className="Entry">
         <div className="jakubko_test2">
     
        <div style={{ padding: '42.5% 0 0 0', top: '0', position:'relative%' }} >
          {/* noborder */}
          {/* <iframe src="https://player.vimeo.com/video/1016123302?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={{ position: 'absolute', top: '0', width:'100%', height:'100%' }} title="TIMEA live session from Oaza" ></iframe> */}
          {/* border */}
          {/* <iframe id="video-container" src="https://player.vimeo.com/video/1016141503?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"  style={{ position: 'absolute', top: '0', width:'100%', height:'100%' }} webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> */}
          <iframe title={found.title} id="video-container" src={found.src} style={{ position: 'absolute', top: '0', width:'100%', height:'100%' }} frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        </div>

        <script src="https://player.vimeo.com/api/player.js"></script>

      </div> 





        {/* <div style="padding:75% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/1016141503?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Sima Magušinová - Z dvoch dlaní"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script> */}


        <div className="Entry-details">
          <h1 className="Entry-title">{found.title}</h1>
          <p>{found.desc}</p>

          <br></br>
          <br></br>


          {  (found.client_people.length !== 0)
       ?  <p className="Entry-subtitle">Songs performed by:</p>
       : <p className="Entry-subtitle"></p>
          }
      
    


         

          {found.client_people.map((x) => (
            <p>({x.title}) {x.person}</p>
          ))}

          <br></br>
          <br></br>
          <p className="Entry-subtitle">Video credits:</p>
          {found.production_people.map((x) => (
            <p>({x.title}) {x.person}</p>

          ))}

        </div>


        <div className="Entry-stills">
          {found.pictures.map((pic) => (
            <figure className="Entry-stillsImage Entry-stillsImage--paddingRegular Entry-stillsImage--verticalAlignmentCenter Entry-stillsImage--horizontalAlignmentCenter js-lazyImage js-zoomImage">
              <img width="3000" height="1257" srcSet="" className="attachment-full size-full" alt="" decoding="async" loading="lazy" sizes="(max-width: 767px) 100vw, 50vw"
                srcset={pic} />
            </figure>
          ))}
        </div>


      </main>


      <div className="Zoom js-zoomContainer"></div>

      < NextProjects data={found}  />
      <Footer2 />

    </React.Fragment >
  );
}




